import { render } from "./TitleColored.vue?vue&type=template&id=1166e672&scoped=true"
import script from "./TitleColored.vue?vue&type=script&lang=js"
export * from "./TitleColored.vue?vue&type=script&lang=js"

import "./TitleColored.vue?vue&type=style&index=0&id=1166e672&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1166e672"]])

export default __exports__